<template>
  <v-row justify="center">
    <v-dialog
      v-if="canShowFeedbackForm"
      v-model="dialog"
      scrollable
      max-width="600"
      open-delay="5000"
      transition="dialog-top-transition"
    >
      <v-card flat rounded>
        <CourseFeedbackForm
          :trainingRegistrationId="trainingRegistration._id"
          :trainingRegistrationData="trainingRegistration"
          :outlined="true"
        />
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import CourseFeedbackForm from "@/app/course-module/components/CourseFeedbackForm";

export default {
  name: "CourseFeedbackFormDialog",
  components: { CourseFeedbackForm },
  props: {
    trainingRegistration: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      dialog: true,
    };
  },
  computed: {
    canShowFeedbackForm() {
      return (
        this.trainingRegistration &&
        !this.trainingRegistration?.feedback &&
        this.trainingRegistration?.training?.feedback?.questionAnswers
          ?.length &&
        (this.trainingRegistration.status === "COMPLETED" ||
          this.isLastModuleContentWithFailedQuiz)
      );
    },
    isLastModuleContentWithFailedQuiz() {
      const currentTrainingProgress =
        this.trainingRegistration.trainingProgresses.find(
          x => x.status === "ON_GOING"
        );

      return (
        currentTrainingProgress?.trainingModuleContent?.contentType ===
          "QUIZ" && !this.canRetryQuiz(currentTrainingProgress)
      );
    },
  },
  methods: {
    canRetryQuiz(trainingProgress) {
      const retryCount = trainingProgress.retryCount ?? 1;

      return (
        !trainingProgress.quizAttempts?.length ||
        trainingProgress.quizAttempts.length < retryCount
      );
    },
  },
};
</script>

<style lang="scss" scoped />
